import common from './common';
import login from './login';
import calendar from './calendar';
import interview from './interview';
import account from './account';
import company from './company';
import product from './product';
import forgotPassword from './forgotPassword';
import resetPassword from './resetPassword';
import error from './error';
import emptyState from './emptyState';
import menu from './menu';

export default {
  common,
  login,
  calendar,
  interview,
  account,
  company,
  product,
  forgotPassword,
  resetPassword,
  error,
  emptyState,
  menu
};
